import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class ContinueFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.Continue;
    }

    getRawFragment(play, serializationContext, continued) {
        let rawPlay = "";

        const formattedFieldPosition = this.resolveFormattedFieldPosition(
            serializationContext,
            continued.getFieldPosition()
        );

        const values = [
            this.resolveUniform(
                serializationContext,
                continued.getPlayers()[0]
            ),
            formattedFieldPosition,
            this.getAdvanceFlag()
        ];

        rawPlay = `+:${values.join()}`;

        return rawPlay;
    }

    getAdvanceFlag() {
        return "C";
    }
}
